// extracted by mini-css-extract-plugin
module.exports = {"associatedProducts":"fs","centerRecos":"gs","subRecos":"hs"};